import { render, staticRenderFns } from "./EditLabourerPage.vue?vue&type=template&id=54f7c12b&scoped=true&"
import script from "./EditLabourerPage.vue?vue&type=script&lang=js&"
export * from "./EditLabourerPage.vue?vue&type=script&lang=js&"
import style0 from "./EditLabourerPage.vue?vue&type=style&index=0&id=54f7c12b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f7c12b",
  null
  
)

export default component.exports